import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import numeral from 'numeral'
import moment from 'moment';

import { toast } from 'react-toastify'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxSection from '../components/Layout/BoxSection'
import SelectorInput from '../components/Shared/SelectorInput'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'
import ModalAddServicio from '../components/CreacionSolicitudServicio/ModalAddServicio'
import AttachedFilesBox from '../components/Shared/AttachedFilesBox'
import ModalAddFile from '../components/Shared/ModalAddFile'


import { showModalSelector, selectFromSelector, getParameterByName } from '../actions/common'
import {
    updateInputs,
    addSolicitudBienesItem,
    editSolicitudBienesItem,
    removeSolicitudBienesItem,
    addCencoSolicitudBienesItem,
    removeCencosSolicitudBienesItem,
    toggleSelectAllSolicitudBienesItems,
    toggleSelectAllSolicitudBienesCencos,
    createSolicitudBienes,
    addSolicitudServicioBIFile,
    removeSolicitudServicioBIFiles,
    enviarComentario,
    editarComentario,
    eliminarComentario
} from '../actions/creacionSolicitudbi'

class CreacionSolicitudBI extends Component {


    componentWillMount() {
        this.props.getParameterByName('UNIDADES')
    }


    handleOpenSelector = (list) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = list
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }

    handleOpenSelectorAddCenco = (list, index) => {
        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }
        ]

        const payload = {}
        const fn = (a) => {
            const index = this.props.creacionsolicitudBI.get('cencos').findIndex(c => c.getIn(['cenco', 'id']) == a.id)
            if (index >= 0) {
                toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
            } else {
                payload.path = list
                payload.value = a
                this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION', payload)
            }

        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.creacionsolicitudBI.getIn(['cencos', index, 'responsable', 'id']), comparison: 'number' }
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
    }

    render() {
        const { creacionsolicitudBI, enums, unidades } = this.props

        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={() => this.props.createSolicitudBienes()} title="Guardar" disabled={creacionsolicitudBI.get('btnSaveDisabled')} />
        ]
        const actionsSectionDetallesBienes = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" onClick={e => this.props.addSolicitudBienesItem()} title="Adicionar bien" />,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={e => this.props.removeSolicitudBienesItem()} title="Eliminar bien"
                    danger disabled={!creacionsolicitudBI.get('bienes').filter(x => x.get('selected')).count()} />
        ]

        const actionsSectionDistribucionCencos = [
            <BoxButton key="ba[2][0]" size={14} contrast name="plus-circle" onClick={e => this.props.addCencoSolicitudBienesItem()} title="Nuevo cenco" />,
            <BoxButton key="ba[2][1]" size={14} contrast name="trash" onClick={e => this.props.removeCencosSolicitudBienesItem()} title="Eliminar"
                    disabled={!creacionsolicitudBI.get('cencos').filter(x => x.get('selected')).count()} />,
        ]

        return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Solicitud de Bienes e Investigación > Creación de solicitud">
                        <ButtonStrip actions={boxActions} />
                        <div className="box-content">
                            <div>

                                <BoxSection title="Información básica">
                                <div className="row">

                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Solicitante</label>
                                                <input type="text" value={this.props.user.get('fullname') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input type="text" value={this.props.user.get('email') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={this.props.user.get('extension') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Área</label>
                                                <input type="text" value={this.props.user.getIn(['area', 'nombre']) || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Responsable de compras</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[7].responsable.fullname || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input className="form-control input-sm" value={enums.solicitudes.tipos[7].responsable.email || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[7].responsable.extension || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de solicitud</label>
                                                <input className="form-control input-sm" value={moment().format('YYYY/MM/DD')} disabled />
                                            </div>
                                        </div>

                                    </div>
                                </BoxSection>



                                <BoxSection title="Información del bien solicitado">

                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label className="control-label">Proyecto/Evento/Actividad</label>
                                                <input type="text" value={creacionsolicitudBI.get('proyecto_evento')} className="form-control input-sm"
                                                    onChange={e => this.props.updateInputs('proyecto_evento', e.target.value)} />
                                            </div>
                                        </div>



                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Almacén</label>
                                                <select className="form-control input-sm" value={creacionsolicitudBI.get('tipo_almacen')}
                                                    onChange={e => this.props.updateInputs('tipo_almacen', e.target.value)}>
                                                    <option value="" disabled>Seleccione el almacén</option>
                                                    <option value="laboratorio">Laboratorio</option>
                                                    <option value="materiales">Materiales</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de entrega</label>
                                                <input type="date" value={creacionsolicitudBI.get('fecha_requerido') || ''} className="form-control input-sm"
                                                    onChange={e => this.props.updateInputs('fecha_requerido', e.target.value)} />
                                            </div>
                                        </div>

                                    </div>
                                </BoxSection>
                                <div className="separator"></div>
                                <BoxSection title="Detalle Bienes" actions={actionsSectionDetallesBienes}>
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                                        <thead>
                                            <tr>
                                                <th width="20">
                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={e => this.props.toggleSelectAllSolicitudBienesItems(e.target.checked)} 
                                                        checked={creacionsolicitudBI.get('bienes').filter(x => x.get('selected')).count() === creacionsolicitudBI.get('bienes').count()} />
                                                </th>
                                                <th style={{ width: '5%' }}>No.</th>
                                                <th style={{ width: '65%' }}>Descripción bienes</th>
                                                <th style={{ width: '10%' }}>Cantidad</th>
                                                <th style={{ width: '20%' }}>Unidad / Presentación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (creacionsolicitudBI.get('bienes').count() > 0) ?
                                                    creacionsolicitudBI.get('bienes').map((x, n) => {
                                                        return (
                                                            <tr key={x.get('id') ? x.get('id') : x.get('guid')} className={x.get('selected') ? 'info' : ''}>
                                                                <td>
                                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }} checked={x.get('selected')} onChange={(e) => this.props.editSolicitudBienesItem(n, {selected: e.target.checked})} />
                                                                </td>
                                                                <td style={{ textAlign: 'right' }} >{n + 1}</td>
                                                                <td><input type="text" value={x.get('descripcion') || ''} className="form-control input-sm" onChange={e => this.props.editSolicitudBienesItem(n, {
                                                                    descripcion: e.target.value
                                                                })} /></td>
                                                                <td><input type="number" value={x.get('cantidad_requerida') || ''} className="form-control input-sm" onChange={e => this.props.editSolicitudBienesItem(n, {
                                                                    cantidad_requerida: e.target.value
                                                                })} min="1" /></td>

                                                                <td>
                                                                  <select
                                                                    className="form-control input-sm"
                                                                    value={x.get('unidad') || ''}
                                                                    onChange={e => this.props.editSolicitudBienesItem(n, { unidad: e.target.value })}
                                                                  >
                                                                    <option value="">Seleccione unidad</option>
                                                                    {unidades && unidades.map((unidad, idx) => (
                                                                      <option key={idx} value={unidad.get('UNIDAD')}>{unidad.get('UNIDAD')}</option>
                                                                    ))}
                                                                  </select>
                                                                </td>


                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td colSpan={5} style={{ textAlign: 'center' }}>Para crear los bienes haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </BoxSection>


                                <div className="separator"></div>
                                <BoxSection title="Distribución de centros de costo" actions={actionsSectionDistribucionCencos}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap">
                                                <thead>
                                                    <tr>
                                                        <th width="20">
                                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={e => this.props.toggleSelectAllSolicitudBienesCencos(e.target.checked)}
                                                                checked={creacionsolicitudBI.get('cencos').filter(x => x.get('selected')).count() === creacionsolicitudBI.get('cencos').count()} />
                                                        </th>
                                                        <th style={{ width: '45%' }}>Responsable Cenco</th>
                                                        <th style={{ width: '45%' }}>Cenco</th>
                                                        <th style={{ width: '10%' }}>Porcentaje(%)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        creacionsolicitudBI.get('cencos').map((x, n) => {
                                                            return (
                                                                <tr key={`tr[${x.get('guid')}]`} className={x.get('selected') ? 'info-dark' : ''} >
                                                                    <td style={{ width: '20px' }} >
                                                                        <input type="checkbox" style={{ marginTop: '6px' }} checked={x.getIn('selected')} 
                                                                            onChange={(e) => this.props.updateInputs(`cencos.${n}.selected`, e.target.checked)} />
                                                                    </td>
                                                                    <td style={{ width: '50%' }}>
                                                                        <SelectorInput value={x.getIn(['responsable', 'fullname']) || ''} onClick={() => this.handleOpenSelector(`cencos.${n}.responsable`)}
                                                                            onReset={() => this.props.updateInputs(`cencos.${n}.responsable`, null)} />
                                                                    </td>

                                                                    <td style={{ width: '30%' }}>
                                                                        {
                                                                            x.get('responsable') ? (
                                                                                <SelectorInput value={x.get('cenco') ? x.getIn(['cenco', 'codigo']) : ''} onClick={() => this.handleOpenSelectorAddCenco(`cencos.${n}.cenco`, n)}
                                                                                    onReset={() => this.props.updateInputs(`cencos.${n}.cenco`, null)} />
                                                                            ) : (
                                                                                    <input className="form-control input-sm" placeholder="Seleccione un responsable del cenco" disabled />
                                                                                )
                                                                        }
                                                                    </td>

                                                                    <td style={{ width: '20%' }}>
                                                                        <input type="number" className="form-control input-sm" placeholder="Porcentaje"value={x.get('porcentaje')}
                                                                            onChange={(e) => this.props.updateInputs(`cencos.${n}.porcentaje`, e.target.value)} disabled={x.get('responsable') == null} />
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Observaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea type="text" className="form-control input-sm" rows={4} value={creacionsolicitudBI.get('observaciones')} onChange={(e) => this.props.updateInputs('observaciones', e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>
                                
                                <AttachedFilesBox
                                    files={ creacionsolicitudBI.get('adjuntos') }
                                    removeFiles = { this.props.removeSolicitudServicioBIFiles }
                                    updateInputs = { this.props.updateInputs }
                                    obj={ creacionsolicitudBI }
                                    check={ 'solicitud' }
                                />


                                <div className="separator"></div>

                                <BoxSection title="Recomendaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <table className="table table-condensed table-bordered table-sorted" style={{ backgroundColor: '#eee' }}>
                                                <tbody>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>SI EL EQUIPO REQUIERE ACCESORIOS (KIT DE HERRAMIENTAS O PARTES) ADICIONALES PARA SU FUNCIONAMIENTO, DEBE RELACIONARLO EN EL SIGUIENTE CUADRO</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>EN LA DESCRIPCIÓN DE LOS BIENES, FAVOR INDICAR MARCA, MODELO, CARACTERÍSTICAS Y ESPECIFICACIONES.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </BoxSection>



                            </div>


                        </div>
                    </Box>
                </div>
                <ModalAddServicio />

                <ModalSelectorFromList />

                <ModalAddFile
                    action={() => this.props.addSolicitudServicioBIFile()}
                />


            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),
        creacionsolicitudBI: state.creacionsolicitudBI,
        enums: state.common.get('enums').toJS(),
        responsable: state.common.getIn(['parametros', 'SOLICITUDES']) ? state.common.getIn(['parametros', 'SOLICITUDES']).filter(x => x.get('TIPO_SOLICITUD') == state.creacionsolicitudBI.get('tipo')).first() : null,
        unidades: state.common.getIn(['parametros', 'UNIDADES']),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        showModalSelector: (title, fields, url, action, filters) => dispatch(showModalSelector(title, fields, url, action, filters)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        addSolicitudBienesItem: () => dispatch(addSolicitudBienesItem()),
        editSolicitudBienesItem: (index, data) => dispatch(editSolicitudBienesItem(index, data)),
        removeSolicitudBienesItem: () => dispatch(removeSolicitudBienesItem()),
        addCencoSolicitudBienesItem: () => dispatch(addCencoSolicitudBienesItem()),
        removeCencosSolicitudBienesItem: () => dispatch(removeCencosSolicitudBienesItem()),
        toggleSelectAllSolicitudBienesItems: (checked) => dispatch(toggleSelectAllSolicitudBienesItems(checked)),
        toggleSelectAllSolicitudBienesCencos: (checked) => dispatch(toggleSelectAllSolicitudBienesCencos(checked)),
        createSolicitudBienes: () => dispatch(createSolicitudBienes()),
        addSolicitudServicioBIFile: () => dispatch(addSolicitudServicioBIFile()),
        removeSolicitudServicioBIFiles: () => dispatch(removeSolicitudServicioBIFiles()),
        enviarComentario: () => dispatch(enviarComentario()),
        eliminarComentario: (guid) => dispatch(eliminarComentario(guid)),
        editarComentario: (guid) => dispatch(editarComentario(guid)),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreacionSolicitudBI)



// WEBPACK FOOTER //
// ./src/containers/CreacionSolicitudBI.jsx